<template>
  <div class="side-panel">
    <div class="side-panel-header" id="side-panel-header">
      <span class="level-header-text">Level {{ level + 1 }}</span>
      <div class="numbers" id="number-container">
        <div
          v-for="i in Math.max(0, step)"
          class="empty-number-done"
          :key="`before-${i}`"
        ></div>
        <div
          v-for="i in Math.max(0, maxSteps - step)"
          class="empty-number"
          :key="`after-${i}`"
        ></div>
      </div>
      <div
        style="position: absolute; left: 0.5rem; bottom: 0.5rem"
        class="level-change-button"
        :class="{ 'icon-throb': level > 0, invisible: level == 0 }"
        v-ripple
        @click="prevLevel"
      >
        <svg width="3rem" height="3rem" viewBox="0 0 24 24">
          <path :d="mdiChevronLeft" fill="#cdf4dd" />
        </svg>
      </div>
      <div
        style="position: absolute; right: 0.5rem; bottom: 0.5rem"
        class="level-change-button"
        :class="{
          'icon-throb': level < maxLevelAchieved,
          invisible: level >= maxLevelAchieved,
        }"
        v-ripple
        @click="nextLevel"
        v-if="level < maxLevelAchieved"
      >
        <svg width="3rem" height="3rem" viewBox="0 0 24 24">
          <path :d="mdiChevronRight" fill="#cdf4dd" />
        </svg>
      </div>
      <IconButton @click="$emit('close')" type="close" class="close-button" />
    </div>

    <!--<div class="panel-content" id="panel-content-container">
      <ActionCard
        v-for="k in actionKeys"
        :key="k"
        :actionKey="k"
        :id="k"
        @click="clickCard(k)"
      />
    </div>-->
    <div class="multi-panel-content-container">
      <transition name="panelcontent">
        <PanelContent
          v-if="level == 0"
          :level="0"
          :style="panelSlideVariable"
          @clickCard="clickCard"
        />
      </transition>
      <transition name="panelcontent">
        <PanelContent
          v-if="level == 1"
          :level="1"
          :style="panelSlideVariable"
          @clickCard="clickCard"
        />
      </transition>
      <transition name="panelcontent">
        <PanelContent
          v-if="level == 2"
          :level="2"
          :style="panelSlideVariable"
          @clickCard="clickCard"
        />
      </transition>
    </div>
    <BottomPopupNew
      v-if="showBottomPopup"
      @close="showBottomPopup = false"
      :moveKey="moveKey"
    />
    <transition name="discover">
      <DiscoverPopup
        v-if="showDiscoverPopup"
        :moveKey="moveKey"
        @close="showDiscoverPopup = false"
      />
    </transition>
    <transition name="fade-in">
      <TutorialSidePanel
        v-if="showTutorial"
        :positions="panelPositions"
        @close="showTutorial = false"
      />
    </transition>
  </div>
</template>

<script>
import IconButton from '@/components/IconButton.vue'
//import ActionCard from '@/components/ActionCard.vue'
import BottomPopupNew from '@/components/BottomPopupNew.vue'
import DiscoverPopup from '@/components/DiscoverPopup.vue'
import PanelContent from '@/components/PanelContent.vue'
//import HeightSwitcher from '@/components/HeightSwitcher.vue'
import TutorialSidePanel from '@/components/TutorialSidePanel.vue'

import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'

export default {
  name: 'SidePanel',
  components: {
    IconButton,
    //ActionCard,
    BottomPopupNew,
    DiscoverPopup,
    PanelContent,
    TutorialSidePanel,
    //HeightSwitcher,
  },
  data() {
    return {
      offset: 0,
      maxSteps: 6,
      showBottomPopup: false,
      showDiscoverPopup: false,
      //discoverPopupKey: Date.now(),
      //actionKeys: undefined,
      hintVisible: false,
      moveKey: undefined,
      heightSwitcherUnlocked: false,
      mdiChevronLeft,
      mdiChevronRight,
      panelSlideVariable: {
        '--slide-enter-percentage': '100%',
        '--slide-leave-percentage': '-100%',
      },
      showTutorial: false,
      panelPositions: {},
      scrollTo: undefined,
    }
  },
  mounted() {
    window.addEventListener('resize', this.updatePanelPositions)
    setTimeout(() => {
      if (
        this.$store.getters.level == 0 &&
        this.$store.getters.unlockedActions.length >= 1 &&
        !this.$store.getters.libraryTutorialSeen &&
        this.$store.getters.userWantsTutorial
      ) {
        this.showTutorial = true
      }
    }, 333)
  },
  beforeDestroy() {
    console.log('SidePanel beforeDestroy')
    window.removeEventListener('resize', this.updatePanelPositions)
  },
  computed: {
    step() {
      return this.$store.getters.unlockedActionsCount
    },
    unlockedActions() {
      return this.$store.getters.unlockedActions
    },
    lockedActions() {
      return Object.keys(this.$store.getters.actions).filter(
        (x) => !this.unlockedActions.includes(x)
      )
    },
    level() {
      return this.$store.getters.level
    },
    maxLevelAchieved() {
      return this.$store.getters.maxLevelAchieved
    },
    /*actionKeys() {
      //return Object.keys(this.$store.getters.actions)
      return [...this.unlockedActions, ...this.lockedActions]
    },*/
  },
  methods: {
    /*scrollPanelTo(id) {
      this.scrollTo = undefined
      this.scrollTo = id
    },
    updatePanelPositions() {
      //debugger
      let positions = {}
      Object.keys(this.$store.getters.actions).forEach((k) => {
        positions[k] = document.getElementById(k).getBoundingClientRect()
      })

      let elem = document.getElementById('side-panel-header')
      if (!(elem === null)) {
        positions['side-panel-header'] = elem.getBoundingClientRect()
      }

      console.log('updatePanelPositions', positions)
      this.panelPositions = positions
    },*/
    convertRemToPixels(rem) {
      return (
        rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
      )
    },
    clickCard(moveKey) {
      if (
        this.$store.getters.isActionUnlocked(moveKey) ||
        this.$store.getters.isActionRevealed(moveKey)
      ) {
        console.log('showDiscoverPopup')
        this.moveKey = moveKey
        this.showDiscoverPopup = true
      } else {
        console.log('showBottomPopup')
        this.moveKey = moveKey
        this.showBottomPopup = true
      }
    },
    nextLevel() {
      this.panelSlideVariable = {
        '--slide-enter-percentage': '100%',
        '--slide-leave-percentage': '-100%',
      }
      this.$nextTick(() => {
        this.$store.commit(
          'SET_LEVEL',
          Math.min(this.$store.getters.level + 1, 2)
        )
      })
    },
    prevLevel() {
      this.panelSlideVariable = {
        '--slide-enter-percentage': '-100%',
        '--slide-leave-percentage': '100%',
      }
      this.$nextTick(() => {
        this.$store.commit(
          'SET_LEVEL',
          Math.max(this.$store.getters.level - 1, 0)
        )
      })
    },
  },
}
</script>

<style>
.side-panel {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  background-color: rgba(3, 28, 33);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.side-panel-header {
  /*position: absolute;
  top: 0px;*/
  position: relative;
  width: 100%;
  /*background-color: #003745; previous*/
  /*background-color: rgba(0, 55, 69, 0.5);*/
  background-color: rgba(3, 28, 33);
  /*backdrop-filter: blur(5px);*/
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1rem 2rem 1rem;
  box-sizing: border-box;
  border-bottom: 2px solid #cdf4dd;
  z-index: 99;
}

.level-header-text {
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 1rem;
  line-height: 1;
}

.multi-panel-content-container {
  position: relative;
  overflow: hidden;
  overflow: hidden;
  height: 100%;
  flex-shrink: 1;
}

.close-button {
  position: absolute;
  left: 1rem;
  top: 1rem;
  z-index: 100;
}

.numbers {
  font-size: 0.5rem;
}

.numbers > * + * {
  margin-left: 0.75em;
}

.empty-number {
  display: inline-block;
  font-size: 1.5em;
  border-radius: 50%;
  width: 1em;
  height: 1em;
  border: 1px solid #cdf4dd;
  background-color: transparent;
}

.empty-number-done {
  display: inline-block;
  font-size: 1.5em;
  border-radius: 50%;
  width: 1em;
  height: 1em;
  border: 1px solid #cdf4dd;
  background-color: #cdf4dd;
}

.invisible {
  visibility: hidden;
}

.discover-enter.discoverpopup-fullscreen,
.discover-leave-to.discoverpopup-fullscreen {
  background-color: rgba(0, 0, 0, 0);
}

.discover-enter .discover-container,
.discover-leave-to .discover-container {
  opacity: 0;
  transform: scale(0.7);
}

.panelcontent-enter {
  transform: translate(var(--slide-enter-percentage), 0);
}

.panelcontent-leave-to {
  transform: translate(var(--slide-leave-percentage), 0);
}

.level-change-button {
  border-radius: 50%;
  cursor: pointer;
  color: #cdf4dd;
}

.icon-throb path {
  animation-name: icon-throb-animation;
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transform-origin: center;
}

@keyframes icon-throb-animation {
  from {
    /*fill: #cdf4dd;*/
    transform: scale(1);
  }
  to {
    /*fill: #e0a800;*/
    transform: scale(1.2);
  }
}

.fade-in-enter {
  opacity: 0;
}

.fade-in-enter-active {
  transition: opacity 0.5s;
}

.fade-in-leave-to {
  opacity: 0;
}

.fade-in-leave-active {
  transition: opacity 0.5s;
}

/*
.discover-enter .discover-container {
  transform: translateY(-25px);
}

.discover-leave-to .discover-container {
  transform: translateY(25px);
}*/
</style>
